"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShipmentLineSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class ShipmentLineSearchResponse extends common_1.PaginatedResponse {
}
exports.ShipmentLineSearchResponse = ShipmentLineSearchResponse;
//# sourceMappingURL=shipment-line-search.response.js.map